import { render, staticRenderFns } from "./JdsAttributeField.vue?vue&type=template&id=d04989c4&scoped=true&"
import script from "./JdsAttributeField.vue?vue&type=script&lang=ts&"
export * from "./JdsAttributeField.vue?vue&type=script&lang=ts&"
import style0 from "./JdsAttributeField.vue?vue&type=style&index=0&id=d04989c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04989c4",
  null
  
)

export default component.exports